import { render, staticRenderFns } from "./createPlan.vue?vue&type=template&id=33511432&scoped=true"
import script from "./createPlan.vue?vue&type=script&lang=js"
export * from "./createPlan.vue?vue&type=script&lang=js"
import style0 from "./createPlan.vue?vue&type=style&index=0&id=33511432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33511432",
  null
  
)

export default component.exports